// Shared module-option normalization used by every Admin Configurations screen
// (Form Groups, Detail Groups, Row Actions, Module Action Rules, Templates,
// Role Configuration) so there is exactly one place that turns whatever shape
// the backend returns (menus collection docs, modules collection docs, or a
// bare string) into a consistent { value, label } option list.

export function moduleTitle(value) {
  return String(value || '')
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function normalizeModuleOption(module) {
  if (typeof module === 'string') {
    return { value: module, label: moduleTitle(module) };
  }
  const value = (
    module?.menuKey ?? module?.module ?? module?.key ?? module?.moduleKey ?? module?.value ??
    module?.apiModule ?? module?.name ?? module?.modulename ?? module?.menuName
  );
  if (!value) return null;
  return {
    value,
    label: (
      module?.menuName ?? module?.label ?? module?.moduleLabel ?? module?.moduleName ??
      module?.name ?? module?.modulename ?? moduleTitle(value)
    ),
  };
}

export function normalizeModuleOptions(modules) {
  const seen = new Set();
  return (Array.isArray(modules) ? modules : [])
    .map(normalizeModuleOption)
    .filter(Boolean)
    .filter((module) => {
      if (seen.has(module.value)) return false;
      seen.add(module.value);
      return true;
    });
}
